/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3HIcon16Regular = forwardRef('UiMenuDots3HIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.75 8a1.248 1.248 0 1 0 2.497 0A1.248 1.248 0 0 0 1.75 8Z" }),
        React.createElement("path", { d: "M8 9.248a1.248 1.248 0 1 1 0-2.496 1.248 1.248 0 0 1 0 2.496Z" }),
        React.createElement("path", { d: "M13.002 9.248a1.248 1.248 0 1 1 0-2.496 1.248 1.248 0 0 1 0 2.496Z" })));
});
